"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prescriptionHandlers = exports.getPrescriptionByScriptNumber = exports.getPrescriptions = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function getPrescriptions(prescriptionParams) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Prescription",
        method: "GET",
        params: {
            StartDate: prescriptionParams.startDate,
            EndDate: prescriptionParams.endDate,
            PageNumber: prescriptionParams.pageNumber,
            PageSize: prescriptionParams.pageSize,
            Search: prescriptionParams.search,
            DoctorName: prescriptionParams.doctorName,
            "SortBy.FieldName": prescriptionParams.sortBy,
            "SortBy.Direction": "desc",
            ReadyForRefill: prescriptionParams.readyForRefill,
            Inactive: prescriptionParams.onFile,
            TransferredOut: prescriptionParams.transferredOut,
            RequiresRenewal: prescriptionParams.requiresRenewal,
            Scheduled: prescriptionParams.scheduled,
            ReadyForPickUp: prescriptionParams.readyForPickup,
            InProgress: prescriptionParams.inProgress,
            PatientId: prescriptionParams.patientId,
        },
    })
        .then(function (result) { return result.data; });
}
exports.getPrescriptions = getPrescriptions;
var mockPrescriptions = [
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 259841,
        refillsAuthorized: 0,
        refillUntilDate: "2023-06-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: true,
        status: "Scheduled",
        statusText: "Scheduled for refill",
        expectedPickupDate: "2022-10-24T00:00:00",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 10.0,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: null,
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 30.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: "Source",
        refillProgram: "Medsync",
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 73502,
        refillsAuthorized: 9,
        refillUntilDate: "2023-06-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "2",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "2",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: false,
        status: "Scheduled",
        statusText: "Scheduled for refill",
        expectedPickupDate: "2022-09-01T00:00:00",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-22T00:00:00",
                quantityDispensed: 30,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 130.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: false,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: "Auto Refill",
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 166326,
        refillsAuthorized: 9,
        refillUntilDate: "2023-06-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: false,
        status: "ReadyForPickup",
        statusText: "Ready for pickup",
        expectedPickupDate: "2022-10-24T00:00:00",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: null,
                quantityDispensed: 0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 130.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: "Refill will require additional approval from MD. Or just steal it, your choice.",
        orderSource: null,
        refillProgram: "Facility Cycle Fill",
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 513,
        refillsAuthorized: 9,
        refillUntilDate: "2023-06-24T00:00:00",
        expectedPickupDate: "2022-10-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG WITH LONG NAME FOR TESTING PURPOSES",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: false,
        status: "DoNotShow",
        statusText: "Some long text message for testing purposes. This is a dinosaur.",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 4.01,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: "Facility Cycle Fill",
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 259810,
        refillsAuthorized: 0,
        refillUntilDate: "2023-06-24T00:00:00",
        expectedPickupDate: "2022-10-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: true,
        status: "Scheduled",
        statusText: "Scheduled for refill",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 5.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: null,
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 259876,
        refillsAuthorized: 0,
        refillUntilDate: "2023-06-24T00:00:00",
        expectedPickupDate: "2022-10-24T00:00:00",
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: true,
        status: "OutOfRefills",
        statusText: "Out of refills",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 515.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: null,
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 500077,
        refillsAuthorized: 9,
        refillUntilDate: "2023-06-24T00:00:00",
        expectedPickupDate: null,
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: false,
        status: "Processing",
        statusText: "Processing",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 414.0,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 59.9,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 82401,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 60.23,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 23.5,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 20.0,
                daysSupply: 5,
            },
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 30.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: null,
    },
    {
        writtenDate: "2022-06-22T00:00:00",
        scriptNumber: 259873,
        refillsAuthorized: 9,
        refillUntilDate: "2023-06-24T00:00:00",
        expectedPickupDate: null,
        drugPrescribed: {
            ndcNumber: "45963055650",
            name: "GABAPENTIN CAP 300MG",
            manufacturer: "ACTAVIS",
            schedule: "",
            monograph: null,
            strength: "300MG",
            form: "CAPS",
            imageUrl: "",
            mixture: "1",
        },
        prescriber: {
            name: {
                firstName: "Justin",
                middleInitial: "J",
                lastName: "TEST",
            },
            address: {
                street1: "1400 Lavaca St.",
                street2: null,
                city: "Austin",
                state: "TX",
                zip: "72374",
            },
        },
        isAutoFill: false,
        status: "Scheduled",
        statusText: "Scheduled for refill",
        fills: [
            {
                refillNumber: 0,
                dispenseDate: "2022-06-24T00:00:00",
                quantityDispensed: 30.0,
                sigs: "ONE (1)",
                drugImageUrl: null,
                patientPay: 3.0,
                daysSupply: 5,
            },
        ],
        quantity: 30,
        instructions: "Take with food",
        daysSupply: 6,
        refillable: true,
        refillsRemaining: "3 refills left",
        refillableMessage: null,
        orderSource: null,
        refillProgram: null,
    },
];
mock.getPrescriptions = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Prescription"), function (req, res, ctx) {
        var pageNumber = req.url.searchParams.get("PageNumber");
        return res(ctx.status(200), ctx.delay(2000), ctx.json({
            prescriptions: mockPrescriptions.map(function (p) { return (__assign(__assign({}, p), { scriptNumber: p.scriptNumber + 100 * parseInt(pageNumber !== null && pageNumber !== void 0 ? pageNumber : "0") })); }),
            totalPrescriptions: 24,
        }));
    });
};
function getPrescriptionByScriptNumber(scriptNumber) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Prescription/".concat(scriptNumber),
        method: "GET",
    })
        .then(function (result) { return (__assign(__assign({}, result.data), { expectedPickupDate: new Date(result.data.expectedPickupDate) })); });
}
exports.getPrescriptionByScriptNumber = getPrescriptionByScriptNumber;
mock.getPrescriptionByScriptNumber = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Prescription/:scriptNumber"), function (req, res, ctx) {
        return res(ctx.status(200), ctx.delay(2000), ctx.json(mockPrescriptions.find(function (prescription) {
            return prescription.scriptNumber === +req.params.scriptNumber;
        }) || mockPrescriptions[0]));
    });
};
exports.prescriptionHandlers = mock;
